<template>
    <div class="mainQuestions">
        <div class="questionItems">
            <div class="tab-menu">
                {{ activeQuestion.name }}
            </div>
            <div class="menu-question">
                <ul>
                    <el-divider></el-divider>
                    <div v-for="(item, index) in activeQuestion.list" :key="index">
                        <li style="list-style-type: disc;" @click="toAnswer(item)">{{ item.q }}</li>
                        <el-divider></el-divider>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'question',
    props: ['activeQuestion'],
    data() {
        return {};
    },
    methods: {
        toAnswer(item) {
            this.$emit('questionMessage', item.id);
        },
    },
    created() {},
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.mainQuestions {
  height 100%
  width 100%
}
.questionItems {
  height 100%
  width 100%
  margin-left 2.5%
}
.tab-menu{
  height 5%
  width 100%
  color black
  font-size 1.8rem
  padding-top 28px
  font-weight bold
}
.menu-question {
  height 100%
  width 98%
  color black
  overflow auto
}
.menu-question li {
  font-size 1.1rem
  margin-left 20px
  cursor pointer
}
.menu-question li:hover {
  color #0C78E2
}
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/question.vue